module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/salary-slips/salary/salary.component.css
// module id = ./src/app/pages/functions/salary-slips/salary/salary.component.css
// module chunks = main